import { createGetDataReducer } from "./CommonReducer";
import { CONTACTLIST , CONTACTDETAILS  , CONTACTUPDATESTATUS} from "../../Constants/Contact_us";

export const ContactListReducer = createGetDataReducer( CONTACTLIST );
export const ContactDetailsReducer = createGetDataReducer( CONTACTDETAILS );
export const ContactStatusReducer = createGetDataReducer( CONTACTUPDATESTATUS );




